import { PrismicLink, PrismicSharpImage, TextFromRichText } from './PrismicTypes';

export const LOAN_OPTIONS_WIDGET = 'PrismicGenericTemplateDataBodyLoanOptionsWidget';

export interface LoanOptionsWidgetPrimary {
    // Content fields (editable from Prismic)
    hero_heading?: TextFromRichText;
    hero_subtitle?: TextFromRichText;
    appointment_text?: TextFromRichText;
    appointment_subtitle?: TextFromRichText;
    appointment_button_text?: TextFromRichText;
    appointment_button_link?: PrismicLink;
    image_car?: PrismicSharpImage;
    image_personal?: PrismicSharpImage;
    image_business?: PrismicSharpImage;
    image_equipment?: PrismicSharpImage;
    image_home?: PrismicSharpImage;
}

export interface LoanOptionsWidgetContent {
    __typename: typeof LOAN_OPTIONS_WIDGET;
    primary: LoanOptionsWidgetPrimary;
}
